<script setup>
import { ref, computed } from 'vue'
import BaseEnterCode from '@/components/ui/BaseEnterCode.vue';
import { useLangStore } from '@/stores/storeLang';
import { useRequestsStore } from '@/stores/storeRequests';
import { useSettingsStore } from '@/stores/storeSettings';

const storeLang = useLangStore()
const storeRequests = useRequestsStore()
const storeSettings = useSettingsStore()

const currentTitle = computed(() => {
	if(storeSettings.statusStockFuture) {
		return storeLang.t.stockStatus['notStartedTitle']
	}
	if(storeSettings.statusStockClosed) {
		return storeLang.t.stockStatus['endedTitle']
	} 
})

</script>

<template>
	<div class="code-page inner">
		<div class="header">
			<h1 class="title1">{{ currentTitle }}</h1>
		</div>
		<img class='code-page__img'  width="393" height="472" :src='storeLang.t.codePage["mainImg"]' alt='изображение'>
		
	</div>
</template>

<style lang="scss" scoped>
.code-page {
	position: relative;	
}
.code-page__img {
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	top: 160%;
	width: calc((393 / var(--base-size)) * 100vh);
}
</style>
